/**
 * PUBLIC ROUTE
 * Route component for public pages (login, etc.)
 */

import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { ROUTES } from '@/config/routes.config';

interface PublicRouteProps {
  children: ReactNode;
  redirectIfAuthenticated?: boolean;
  redirectTo?: string;
}

function PublicRoute({
  children,
  redirectIfAuthenticated = true,
  redirectTo = ROUTES.DASHBOARD,
}: PublicRouteProps) {
  const { isAuthenticated, loading } = useAuth();

  // Don't redirect while checking auth status
  if (loading) {
    return <>{children}</>;
  }

  // Redirect authenticated users to dashboard
  if (isAuthenticated && redirectIfAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  // Show public page
  return <>{children}</>;
}

export default PublicRoute;
